import type { ProductPriceDetailDto } from '@/types/api/product';

/** 클래스 폼용: 선택된 productPriceId가 아직 prices에 없을 때(로딩 직후·비활성 SKU 등) Select 항목이 비지 않도록 임시 행을 붙입니다. */
export function buildClassPriceSelectOptions(
    prices: ProductPriceDetailDto[] | undefined,
    selectedProductPriceId: number,
    legacyOptionLabel: string
): ProductPriceDetailDto[] {
    const base = prices ?? [];
    if (selectedProductPriceId <= 0) return base;
    if (base.some((p) => p.productPriceId === selectedProductPriceId)) return base;
    return [
        ...base,
        {
            skuCode: '—',
            productPriceId: selectedProductPriceId,
            title: legacyOptionLabel,
            regularPrice: 0,
            currency: 'KRW',
            purchaseType: 'PER_USER',
            isActive: false,
        },
    ];
}
